import getStore from '../store/store';
import { mutator } from 'satcheljs';
import { setServiceCallState } from '../actions/internalActions';

export default mutator(setServiceCallState, actionMessage => {
    getStore().serviceCallState = actionMessage.state;
});
